import { default as React, } from "react";
import { revoSizeToPadding, sortedRevoBreakpoints, } from "../components/util/layoutconstants";
import { isString, isNumber, isNullOrUndefined } from "../better/utils";
import { getThemeColorVar } from "../helper/color";
import classNames from "classnames";
import { revoSpecToCss } from "../helper/responsive";
import { css, cx } from "emotion";
export function computeGridAttribute(span, start, end) {
    if (span && end) {
        return `span ${span} / ${end}`;
    }
    else if (span && start) {
        return `${start} / span ${span}`;
    }
    else if (span) {
        return `span ${span} / auto`;
    }
    else {
        return `${start || "auto"} / ${end || "auto"}`;
    }
}
export function determinePreviousValue(i, previousKey, propKey) {
    const previousProps = i[previousKey];
    return previousProps ? previousProps[propKey] : undefined;
}
export function determineFinalValue(spec, key, previousValue, propKey) {
    const maybeSpec = spec[key];
    return maybeSpec ? maybeSpec : previousValue[propKey];
}
export function rawGridSpecToGridProp(start, span, end) {
    if (typeof start == "object" ||
        typeof span == "object" ||
        typeof end == "object") {
        return sortedRevoBreakpoints.reduce((i, key, index, keys) => {
            const previousKey = keys[index === 0 ? 0 : index - 1];
            const previousValue = {
                start: start && typeof start === "object"
                    ? determinePreviousValue(i, previousKey, "start")
                    : start,
                span: span && typeof span === "object"
                    ? determinePreviousValue(i, previousKey, "span")
                    : span,
                end: end && typeof end === "object"
                    ? determinePreviousValue(i, previousKey, "end")
                    : end,
            };
            i[key] = {
                start: start && typeof start === "object"
                    ? determineFinalValue(start, key, previousValue, "start")
                    : start,
                span: span && typeof span === "object"
                    ? determineFinalValue(span, key, previousValue, "span")
                    : span,
                end: end && typeof end === "object"
                    ? determineFinalValue(end, key, previousValue, "end")
                    : end,
            };
            return i;
        }, {});
    }
    else if (start || span || end) {
        return {
            start: start,
            span: span,
            end: end,
        };
    }
    else {
        return undefined;
    }
}
export const GridItem = (props) => {
    const classes = [];
    const { backgroundColor } = props;
    const style = {};
    const emotionStyles = [
        Object.assign({ zIndex: props.zIndex }, (props.enablePointerEventPassthrough
            ? {
                pointerEvents: "none",
                "> *": {
                    pointerEvents: "initial",
                },
            }
            : {})),
    ];
    backgroundColor &&
        classes.push(css({
            backgroundColor: getThemeColorVar(backgroundColor.color, backgroundColor.colorType),
        }));
    const colProps = rawGridSpecToGridProp(props.colStart, props.colSpan, props.colEnd);
    const rowProps = rawGridSpecToGridProp(props.rowStart, props.rowSpan, props.rowEnd);
    colProps &&
        emotionStyles.push(revoSpecToCss(colProps, (i) => ({
            gridColumn: computeGridAttribute(i.span, i.start, i.end),
        })));
    rowProps &&
        emotionStyles.push(revoSpecToCss(rowProps, (i) => ({
            gridRow: computeGridAttribute(i.span, i.start, i.end),
        })));
    props.padding &&
        emotionStyles.push(revoSpecToCss(props.padding, revoSizeToPadding));
    classes.push(css(emotionStyles));
    if (props.overflow)
        style.overflow = props.overflow;
    if (props.alignSelf)
        style.alignSelf = props.alignSelf;
    if (props.justifySelf)
        style.justifySelf = props.justifySelf;
    if (!isNullOrUndefined(props.minWidth))
        style.minWidth = isString(props.minWidth)
            ? props.minWidth
            : isNumber(props.minWidth)
                ? props.minWidth
                : props.minWidth.join("");
    if (!isNullOrUndefined(props.minHeight))
        style.minHeight = isString(props.minHeight)
            ? props.minHeight
            : isNumber(props.minHeight)
                ? props.minHeight
                : props.minHeight.join("");
    return (React.createElement("div", { style: style, className: classNames("revo-grid__item", cx(classes)) }, props.children));
};
export default GridItem;
//# sourceMappingURL=griditem.js.map